import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'

interface PromoLineProps {
  lineOrientation: 'top' | 'right' | 'bottom' | 'left'
}

const StyledPromoLine = styled.div<PromoLineProps>`
  position: absolute;
  box-sizing: border-box;
  ${({ lineOrientation }) => {
    if (lineOrientation === 'bottom' || lineOrientation === 'top') {
      return css`
        height: 2px;
        width: 100%;
        ${lineOrientation} : 8px;
        left: 0;
        padding: 0 10px;
      `
    } else {
      return css`
        width: 2px;
        height: 100%;
        top: 0;
        ${lineOrientation}: 8px;
        padding: 8px 0;
      `
    }
  }}
`

const StyledPromoLineColorElement = styled.div`
  ${({
    theme: {
      colors: { white },
    },
  }) => css`
    width: 100%;
    height: 100%;
    background-color: ${white};
  `}
`

const PromoLine: FunctionComponent<PromoLineProps> = ({ lineOrientation }) => (
  <StyledPromoLine lineOrientation={lineOrientation}>
    <StyledPromoLineColorElement />
  </StyledPromoLine>
)

export default PromoLine
